module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "ident pagetitre",
    attrs: {
      "epub:type": "titlepage"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagetitre"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "ident_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("The"), _c('br'), _vm._v("Unhiding"), _c('br'), _vm._v("of"), _c('br'), _vm._v("Elijah"), _c('br'), _vm._v("Campbell")])]), _vm._v(" "), _c('h2', {
    staticClass: "ident_stit",
    attrs: {
      "epub:type": "subtitle",
      "role": "doc-subtitle"
    }
  }, [_c('span', [_vm._v("A Novel")])]), _vm._v(" "), _c('div', {
    staticClass: "auteur_ident"
  }, [_c('span', [_vm._v("Kelly Flanagan")])]), _vm._v(" "), _c('div', {
    staticClass: "edit"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.ivpress.com",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "logo",
      "src": "Images/AI_IVP_Books_G.jpg",
      "width": "120"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-690343c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ident1.vue
// module id = 57
// module chunks = 0